import { render, staticRenderFns } from "./NavLinkItem.vue?vue&type=template&id=752c3aeb&scoped=true&"
import script from "./NavLinkItem.vue?vue&type=script&lang=js&"
export * from "./NavLinkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c3aeb",
  null
  
)

export default component.exports